import React, { createContext, useState, useCallback, useEffect, useMemo } from 'react';
import { getProfile } from '../api/endpoints/auth';
import { PERMISSIONS } from '../config/constants';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('adminToken'));
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const userPermissions = useMemo(() => {
    if (!user?.role) return [];
    return PERMISSIONS[user.role] || [];
  }, [user?.role]);

  const hasPermission = useCallback((permission) => {
    return userPermissions.includes(permission);
  }, [userPermissions]);

  useEffect(() => {
    const loadUser = async () => {
      const storedToken = localStorage.getItem('adminToken');
      if (storedToken) {
        try {
          const { data } = await getProfile();
          setUser(data.data);
          setIsAuthenticated(true);
        } catch {
          localStorage.removeItem('adminToken');
          localStorage.removeItem('adminUser');
          setToken(null);
          setUser(null);
          setIsAuthenticated(false);
        }
      }
      setLoading(false);
    };
    loadUser();
  }, []);

  const login = useCallback((token, userData) => {
    localStorage.setItem('adminToken', token);
    localStorage.setItem('adminUser', JSON.stringify(userData));
    setToken(token);
    setUser(userData);
    setIsAuthenticated(true);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, login, logout, isAuthenticated, loading, permissions: userPermissions, hasPermission, role: user?.role }}>
      {children}
    </AuthContext.Provider>
  );
};
